import i18next from "i18next"
import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { TeamPerson } from "~/api/types/TeamPerson"
import { Breadcrumbs } from "~/components/Breadcrumbs/Breadcrumbs"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { TeamCard } from "~/components/TeamCard/TeamCard"
import { TeamCardMain } from "~/components/TeamCardMain/TeamCardMain"
import { Theme } from "~/components/Theme/Theme"

import styles from "./index.module.css"

export const Content: React.FC = () => {
  const teamList = useApiContext("/team/list")
  const { t } = useTranslation()
  const currentLang = i18next.language

  if (!teamList) {
    return null
  }

  const sortPersons = (a: TeamPerson, b: TeamPerson): number => {
    const splittedNameA = a.name.split(" ")
    const splittedNameB = b.name.split(" ")
    const nameA = splittedNameA[splittedNameA.length - 1]
    const nameB = splittedNameB[splittedNameB.length - 1]

    if (currentLang === "en") {
      return nameA > nameB ? 1 : -1
    }

    return a.name > b.name ? 1 : -1
  }

  const filterGroup = (filterBy: string): TeamPerson[] => {
    return teamList
      .filter(({ team }) => team)
      .filter(({ team }) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return team!.includes(filterBy)
      })
      .sort(sortPersons)
  }

  const directors = filterGroup("director")
  const presidents = filterGroup("president")
  const partners = filterGroup("partners")
  const presidentsAndPartners = [...presidents, ...partners].sort(sortPersons)

  const directorMain = directors.find((val) => val.importantDirectors === true)
  const presidentMain = presidents.find((val) => val.importantPresident === true)

  return (
    <Theme theme="light">
      <div className="container">
        <Breadcrumbs />

        <Heading className={styles.Title} like="h1">
          <Raw html={t("team.Title")} />
        </Heading>

        <div className={styles.Inner}>
          <Heading className={styles.SubTitle} id="directors" like="h2">
            <Raw html={t("team.SubTitle.01")} />
          </Heading>

          {directorMain && <TeamCardMain {...directorMain} />}

          <div className={styles.List}>
            {directors.map((item) => {
              if (item.importantDirectors !== true) {
                return <TeamCard key={item.id} {...item} />
              }
            })}
          </div>
        </div>

        <div className={styles.Inner}>
          <Heading className={styles.SubTitle} id="president" like="h2">
            <Raw html={t("team.SubTitle.02")} />
          </Heading>

          {presidentMain && <TeamCardMain {...presidentMain} />}

          <div className={styles.List}>
            {presidentsAndPartners.map((item) => {
              if (item.importantPresident !== true) {
                return <TeamCard key={item.id} {...item} />
              }
            })}
          </div>
        </div>
      </div>
    </Theme>
  )
}
